import { faThumbsDown, faThumbsUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { BandGlyph } from './bandVisuals.utils';

/**
 * The glyphs a banded y-axis is labelled with, shared by every chart that carries one.
 *
 * A banded axis prints no numbers at all — the boundaries are its only landmarks, and each is named
 * by its glyph (`bandedAxisTickLabel` is what enforces that). Which means the glyphs ARE the axis
 * labels: two charts drawing their own would be two charts whose axes read differently while
 * claiming the same bands, so they live here once and both read from them.
 */

/** Gutter reserved for a band axis — wide enough for the two-thumb glyph plus the tick marks. */
export const BAND_AXIS_GUTTER = 76;

/** Edge length of one band icon's box. */
export const BAND_ICON_BOX = 18;

/**
 * The glyph drawn beside the axis at a boundary, naming the band the boundary's marker gives it: the
 * band a boundary opens on the way up, the band beneath it on the way down. Neutral lies on the near
 * side of both of its boundaries, so it never has a glyph of its own.
 *
 * Deliberately slate rather than the band's own colour: on the axis this is furniture telling the
 * reader where a boundary sits, not a verdict on any plotted value. Colouring it green would read
 * as "this chart is good" regardless of where the line actually runs.
 */
export function BandThresholdAxisIcon({ glyph }: { glyph: BandGlyph }) {
  if (glyph === 'excellent' || glyph === 'veryNegative') {
    const icon = glyph === 'excellent' ? faThumbsUp : faThumbsDown;
    return (
      <span className="inline-flex items-center text-slate-700 text-[10px]">
        <FontAwesomeIcon icon={icon} />
        <FontAwesomeIcon icon={icon} className="-ms-1" aria-hidden />
      </span>
    );
  }

  return <FontAwesomeIcon icon={glyph === 'good' ? faThumbsUp : faThumbsDown} className="text-slate-700 text-[10px]" />;
}
